// minimal library entry point.
"use strict";

module.exports = require("./src/index-minimal");